import { tags as t } from '@lezer/highlight';
import { createTheme, CreateThemeOptions } from '@uiw/codemirror-themes';

const defaultTheme: CreateThemeOptions = {
  theme: 'light',
  settings: {
    lineHighlight: '#EEEBFC6e'
  },
  styles: [
    { tag: t.propertyName, color: '#8A61D8' },
    { tag: t.string, color: '#04A060' },
    { tag: t.number, color: '#D63054' },
    { tag: t.bool, color: '#F4A56E' },
    { tag: t.null, color: '#F4A56E' }
  ]
};

const customTheme = createTheme(defaultTheme);

export const disabledTheme = createTheme({
  ...defaultTheme,
  settings: {
    lineHighlight: '#EEEBFC6e',
    background: '#f2f3f3'
  }
});

export default customTheme;
